// helper function to generate query params from an object
import { PatientProfile } from "@modules/authentication/PatientProfileProvider";

import { PatientType } from "./types";

export const getQueryParams = (
  params: Record<string, string | null | undefined>
): string => {
  let query = "";

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      query += `&${key}=${value}`;
    }
  }
  return query;
};

// Utility function to get the current ISO timestamp accurate to the current minute
export const getCurrentMinuteIsoString = () => {
  const currentDate = new Date();
  currentDate.setSeconds(0, 0);
  return currentDate.toISOString();
};

// Utility function to get the ISO timestamp 30 minutes ago
export const get30MinuteInPastIsoString = () => {
  const currentTimeMs = new Date().getTime();
  const thirtyMinMs = 30 * 60 * 1000;
  const thirtyMinAgoDate = new Date(currentTimeMs - thirtyMinMs);
  thirtyMinAgoDate.setSeconds(0, 0);
  return thirtyMinAgoDate.toISOString();
};

export const isSteadyPatient = (patient: PatientProfile) => {
  return patient.patient_type === PatientType.STEADYMD;
};

export const isB2BUser = (patient: PatientProfile) => {
  return patient.is_b2b_user;
};

export const canScheduleSteadyMdAppointment = (
  patient: PatientProfile
): boolean => {
  return patient.has_active_telehealth_plan;
};

export const getMMDDYYYYFormattedDate = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so add 1
  const day = String(date.getDate()).padStart(2, "0");
  const year = String(date.getFullYear());

  // Concatenate the components in the desired format
  return `${month}/${day}/${year}`;
};
